import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import MainInfoComponent from '../components/common/MainInfoComponent';
import MainDataShowup from '../components/common/MainDataShowup';
import ContactRM from '../components/pagedata/ContactRM';
import { useLocation } from 'react-router-dom';
import contact1 from '../assets/backgorund/contact1.jpg';
import ImageCarousel from '../components/ImageCarousel'
const Contact = () => {
  const [readMore, setReadMore] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setReadMore(false);
  }, [location]);
  return (
    <div id="mainDataShowup">
    {!readMore && 
      <ImageCarousel images={[contact1]} />}
      <AnimatePresence mode="wait">
        {readMore ? (
          <motion.div
            key="MainDataShowup"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5 }}
          >
            <MainDataShowup childComponent={ContactRM} />
          </motion.div>
        ) : (
          <MainInfoComponent
            heading="contact snehwan"
            para={
              <>
                <strong>Have questions or feedback? 
                  We’d love to hear from you! </strong>
                If you want to share your thoughts, or have a general inquiry, our team is ready to assist you.
              </>
            }
            readMore="Fill in your details"
            onReadMore={() => setReadMore(true)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};
export default Contact;
